import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

/** Cache de sessão dos posts publicados (listagem + sidebar do detalhe). */
let sessionPosts = null;
let inflight = null;

export async function fetchPublishedBlogPosts({ force = false } = {}) {
  if (!force && sessionPosts) return sessionPosts;
  if (!force && inflight) return inflight;

  inflight = (async () => {
    const db = getFirestore();
    const snapshot = await getDocs(
      query(collection(db, 'blogPosts'), where('status', '==', 'published'))
    );
    const posts = snapshot.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));
    posts.sort((a, b) => {
      const dateA = a.createdAt?.toDate?.() || new Date(a.createdAt || 0);
      const dateB = b.createdAt?.toDate?.() || new Date(b.createdAt || 0);
      return dateB - dateA;
    });
    sessionPosts = posts;
    inflight = null;
    return posts;
  })();

  try {
    return await inflight;
  } catch (error) {
    inflight = null;
    throw error;
  }
}

export function extractBlogCategories(posts) {
  const unique = new Set();
  (posts || []).forEach((post) => {
    if (post.category) unique.add(post.category);
  });
  return Array.from(unique).sort((a, b) => a.localeCompare(b, 'pt-BR'));
}

export function extractBlogCategoryCounts(posts) {
  const categoryCount = {};
  (posts || []).forEach((post) => {
    const category = post.category;
    if (category) {
      categoryCount[category] = (categoryCount[category] || 0) + 1;
    }
  });
  return Object.entries(categoryCount)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);
}

/** Texto leve para busca (sem HTML / sem baixar conteúdo inteiro na comparação). */
export function blogPostSearchText(post) {
  const title = String(post.title || '');
  const tags = String(post.tags || '');
  const excerpt = String(post.excerpt || post.summary || '');
  const content = String(post.content || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .slice(0, 800);
  return `${title} ${tags} ${excerpt} ${content}`.toLowerCase();
}

export function invalidatePublishedBlogPostsCache() {
  sessionPosts = null;
  inflight = null;
}
